import { render, staticRenderFns } from "./ExpertList.vue?vue&type=template&id=36e27c4d&scoped=true"
import script from "./ExpertList.vue?vue&type=script&lang=js"
export * from "./ExpertList.vue?vue&type=script&lang=js"
import style0 from "./ExpertList.vue?vue&type=style&index=0&id=36e27c4d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e27c4d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36e27c4d')) {
      api.createRecord('36e27c4d', component.options)
    } else {
      api.reload('36e27c4d', component.options)
    }
    module.hot.accept("./ExpertList.vue?vue&type=template&id=36e27c4d&scoped=true", function () {
      api.rerender('36e27c4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/system/expert/ExpertList.vue"
export default component.exports